
export default [
  {
    path: '/index',
    component: () => import('@/views/index'),
    name: 'Home Page',
    meta: { title: 'Home Page', icon: 'tn-daiban', noCache: true, affix: true },
    roles:[0,1,2,9]
  }
]
